var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTrailing = function SvgTrailing(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 17.0003C14.1673 18.5651 15.4358 19.8337 17.0007 19.8337C18.5655 19.8337 19.834 18.5651 19.834 17.0003C19.834 15.4355 18.5655 14.167 17.0007 14.167C15.4358 14.167 14.1673 15.4355 14.1673 17.0003Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 8.50033C14.1673 10.0651 15.4358 11.3337 17.0007 11.3337C18.5655 11.3337 19.834 10.0651 19.834 8.50033C19.834 6.93552 18.5655 5.66699 17.0007 5.66699C15.4358 5.66699 14.1673 6.93552 14.1673 8.50033Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 25.5003C14.1673 27.0651 15.4358 28.3337 17.0006 28.3337C18.5655 28.3337 19.834 27.0651 19.834 25.5003C19.834 23.9355 18.5655 22.667 17.0007 22.667C15.4358 22.667 14.1673 23.9355 14.1673 25.5003Z",
    fill: "#828282"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrailing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "trailing.274fd1be5f8efd03ff4031e9d9df431c.svg";